// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {

  // production: false,
  // apiUrl: 'http://192.168.100.4:3011',
  // apiUrl: 'https://localhost:44328',
  // appUrl: 'http://localhost:4202',
  // flmApiUrl: 'http://10.8.0.156:3081',
  // portalApiUrl: 'http://10.8.0.156:3001',
  // realm: 'GoeplaRealm',
  // clientid: 'GoeplaClient',
  // keycloakUrl: 'http://10.8.0.156:8088',
  // useHybridMode: 'false',
  // domain: 'localhost'

  // production: false,
  // // apiUrl: 'http://192.168.100.4:3011',
  // apiUrl: 'https://localhost:44328',
  // appUrl: 'http://localhost:4202',
  // flmApiUrl: 'http://192.168.100.4:3081',
  // portalApiUrl: 'http://192.168.100.4:3001',
  // realm: 'GoeplaRealm',
  // clientid: 'GoeplaClient',
  // keycloakUrl: 'http://192.168.100.4:8088',
  // useHybridMode: 'true',
  // domain: 'localhost'

  production: true,
  apiUrl: window["env"]["APIURL"] || "default",
  appUrl: window["env"]["APPURL"] || "default",
  flmApiUrl: window["env"]["FLMAPIURL"] || "default",
  keycloakUrl: window["env"]["KEYCLOAKURL"] || "default",
  realm: window["env"]["REALM"] || "default",
  clientid: window["env"]["CLIENTID"] || "default",
  portalApiUrl: window["env"]["PORTALAPIURL"] || "default",
  bucket: window["env"]["BUCKET"] || "default"
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
